/* istanbul ignore file */
export const UiSettings = {
  TableMaxHeight: "720px",
  TableDefaultLimit: 10,
  TableDefaultPage: 1,
  TableDefaultLimitOptions: [5, 10, 25, 50, 100, 200],
};
